<template>
  <div class="v2-time-control">
    <div class="time-control-content">
      <ul class="ul">
        <li class="li"  v-for="(item,index) in dataList" :key="index">
          <div class="parameter-name">
            <!-- <img src="../../assets/images/equipPhoto1.png" alt=""> -->
            <img :src="item.photo.length>100?item.photo:require('../../assets/images/equipPhoto'+item.photo+'.png')">
            <p class="equipment-name">{{item.name}}</p>
          </div>
          <div class="parameter-form">
            <p class="form-label">
              <span class="label-name">名&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;称：</span>
              <el-input class="power" v-model="item.name" placeholder="请输入设备名称" >
              </el-input>
            </p>
            <p class="form-label">
              <span class="label-name">额定电压：</span>
              <el-input class="power" v-model="item.voltage" placeholder="请输入额定电压" >
                <i slot="suffix" class="el-input__icon">V</i>
              </el-input>
            </p>
            <p class="form-label">
              <span class="label-name">额定功率：</span>
              <el-input class="power" v-model="item.power" placeholder="请输入额定功率" >
                <i slot="suffix" class="el-input__icon">W</i>
              </el-input>
            </p>
            <p class="choose-line">定时设置</p>
            <div class="time-setting">
              <div class="setTime" v-for="(timerItem, timerIndex) of item.switchTimerCtrlList" :key="timerIndex">
                <span class="dingTime">定时{{timerIndex + 1}}&nbsp;&nbsp;</span>
                <el-input class="t" v-model="timerItem.start1" maxlength="2"></el-input>
                <span style="padding-left:12px;">:</span>
                <el-input class="t" v-model="timerItem.start2" style="margin-left:6px;" maxlength="2"></el-input>
                &nbsp;
                <span style="color:#0077FF">—</span>
                <el-input class="t" v-model="timerItem.end1" maxlength="2"></el-input>
                <span style="padding-left:10px;">：</span>
                <el-input class="t" v-model="timerItem.end2" style="margin-left:0px;" maxlength="2"></el-input>
                <i v-if="timerIndex === item.switchTimerCtrlList.length - 1 && item.switchTimerCtrlList.length < 4" class="el-icon-circle-plus-outline add-timer-btn" @click="addTimer(item)"></i>
              </div>
            </div>
            <div class="upload">
              <span>图&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;片：</span>
              <ul style="" class="clearfix upload-wrap">
                <li class="upload-button" >
                  <input ref="fileSelected" type="file" @change="load($event,index)" />
                  <img src="../../../public/images/img_add.png" alt="" class="add-img">
                  <p >点击修改图片</p>
                  <p>支持jpg/png格式</p>
                  <p>不超过1M</p>
                </li>
                <li class="defalut-img" :class="{active:item.photo ==1}" @click="item.photo =1">
                  <img src="../../assets/images/equipPhoto1.png" alt="">
                </li>
                <li class="defalut-img" :class="{active:item.photo ==2}" @click="item.photo =2">
                  <img src="../../assets/images/equipPhoto2.png" alt="">
                </li>
                <li class="defalut-img" :class="{active:item.photo ==3}" @click="item.photo =3">
                  <img src="../../assets/images/equipPhoto3.png" alt="">
                </li>
                <!-- <li v-if="item.photo.length>100|| imglist[index].imgSrc" class="defalut-img" :class="{active:item.photo.length>100||imglist[index].imgSrc}" @click="item.photo = imglist[index].imgSrc">
                  <img :src="item.photo = imglist[index].imgSrc" alt="" v-if="imglist[index].imgSrc">
                  <img v-else :src="item.photo.length>100?item.photo:require('../../assets/images/equipPhoto'+item.photo+'.png')">
                </li> -->

              </ul>
            </div>
          </div>
        </li>
      </ul>
      <div class="time-control-btn">
        <el-button @click="cancel">取消</el-button>
        <el-button type="primary" @click="save">保存</el-button>
      </div>
    </div>

  </div>
</template>

<script>
import img from '../../services/img'
import equipmentV2 from '../../store/modules/equipmentV2'
import autoControl from '../../store/modules/autoControl'
import { mapActions, mapMutations } from 'vuex'
export default {
  name: 'timeControl',
  data () {
    return {
      photo: '',
      imglist: [
        {
          imgSrc: null
        },
        {
          imgSrc: null
        },
        {
          imgSrc: null
        },
        {
          imgSrc: null
        }
      ],
      name: '',
      dataList: [],
      power: '',
      voltage: '',
      time: []

    }
  },
  watch: {

  },

  mounted () {
    this.setActiveTitle('时间控制')
    this.getTimeControlData(this.$route.query.id).then((list) => {
      if (list) {
        list.forEach((item, index) => {
          if (item.switchTimerCtrlList) {
            item.switchTimerCtrlList.forEach((timerItem, timerIndex) => {
              let startArr = timerItem.startTime.split(':')
              let endArr = timerItem.endTime.split(':')
              timerItem.start1 = startArr[0]
              timerItem.start2 = startArr[1]
              timerItem.end1 = endArr[0]
              timerItem.end2 = endArr[1]
            })
          }
        })
      }
      this.dataList = list
    }).catch((err) => {
      console.log(err)
    })
  },

  methods: {
    ...mapMutations(equipmentV2, ['setActiveTitle']),
    ...mapActions(autoControl, ['getTimeControlData', 'updateTimeControlData']),
    async load (e, index) {
      console.log(e, index)

      let filePath = e.target.files[0]
      let dataUrl = await img.getFileDataUrl(filePath)
      this.imglist[index].imgSrc = await img.getImgBase64(dataUrl, 80, 80)
      console.log(12, this.imglist[index].imgSrc)
    },
    // 取消
    cancel () {
      this.$router.push({
        name: 'equipmentControl'
      })
    },
    // 保存
    save () {
      this.dataList.forEach((item, index) => {
        if (item.switchTimerCtrlList) {
          item.switchTimerCtrlList.forEach((timerItem, timerIndex) => {
            timerItem.startTime = timerItem.start1 + ':' + timerItem.start2
            timerItem.endTime = timerItem.end1 + ':' + timerItem.end2
          })
        }
      })
      console.log(this.dataList)
      this.updateTimeControlData(this.dataList).then((rsp) => {
        this.$Alert.info({
          content: '保存成功',
          duration: 1000,
          status: 'success'
        })
        setTimeout(() => {
          this.$router.push({
            name: 'equipmentControl'
          })
        }, 500)
      }).catch((err) => {
        console.log(err)
        this.$Alert.info({
          content: err.response.data,
          duration: 3000,
          status: 'error'
        })
      })
    },
    addTimer (item) {
      if (item && item.switchTimerCtrlList && item.switchTimerCtrlList.length < 4) {
        item.switchTimerCtrlList.push({
          startTime: '00:00',
          endTime: '00:00',
          start1: '00',
          start2: '00',
          end1: '00',
          end2: '00',
          isEnable: false
        })
      }
    }

  }

}
</script>
<style lang="scss">
.v2-time-control{
  width: 100%;
  padding-bottom: 20px;
  overflow: auto;
  height: calc(100vh - 65px);
}
  .time-control-content{
    // margin-top:20px;
    // height:100%;
    .ul{
      display: flex;
      // justify-content:space-around;
      flex-wrap:wrap;
      // align-items:center;
      .li{
        width:392px;
        min-height:800px;
        background: url('../../assets/images/shijiankongzhi_kuang.png') no-repeat;
        background-size:100% 100%;
        // margin-left:64px;
        margin-left:66px;
        margin-top:30px;
      }
      // .li:first-child,.li:nth-child(2),.li:nth-child(3),.li:nth-child(4){
      //   margin-left:66px;
      // }
      .parameter-name{
        display: flex;
        // justify-content: center;
        align-items: center;
        margin-top:23px;
        margin-left:30px;
        font-family:Microsoft YaHei;
        width: 334px;
        height:114px;
        background: url('../../assets/images/home_icon_bg.png') no-repeat;
        background-size:100% 100%;
        img{
          width:74px;
          height:72px;
          // margin-top: 20px;
          margin-left: 20px;
        }
        .equipment-name{
          font-size:20px;
          margin-left: 80px;
          font-family:Microsoft YaHei;
          color:rgba(255,255,255,1);
        }

      }
      .parameter-form{
        .form-label{
          margin-left:34px;
          margin-top:26px;
        }
        .label-name{
          font-size:15px;
        }
        .el-input {
          width: 232px;
          margin-left: 12px;
        }
        .el-input__inner {
          border: 1px solid #07f;
          color:rgba(255,255,255,1);
          background: none;
          font-size:18px;
          font-family:Microsoft YaHei;
        }
        .el-select{
          width: 232px;
          color:rgba(255,255,255,1);
          margin-left: 12px;
        }
        .el-input__icon {
          height: 100%;
          width: 36px;
          text-align: center;
          -webkit-transition: all .3s;
          transition: all .3s;
          line-height: 40px;
        }
      }
      .choose-line{
        margin-top:20px!important;
        font-size:16px;
        margin-left:34px;
        font-family:Microsoft YaHei;
        color:#fff;
      }
      .time-setting{
        margin-left:64px;
        .setTime{
          margin-top:20px;

          .t{
            margin-right:-6px;
          }
        }
        .dingTime{
          font-size:15px;
          font-family:Microsoft YaHei;
          color:rgba(139,145,159,1);
        }
        .el-input {
          width: 40px;
          height:40px;

        }
        .el-input__inner {
          width: 38px;
          padding: 0 7px;
          border: 1px solid #07f;
          color:rgba(255,255,255,1);
        }

        .add-timer-btn{
          cursor: pointer;
          display: inline-block list-item;
          font-size: 22px;
          margin-top: 9px;
          color: #07f;
          margin-left: 10px;
        }

      }

    }
  }
  .upload{
    margin-left:40px;
    margin-top:50px;
    .el-upload--picture-card{
      float: left;
      width: 110px;
      height: 100px;
      margin-right:10px;
      margin-bottom:10px;
      padding: 10px 0;
      line-height: normal;
      border: 1px solid #07f;
      background: none;
    }
    .upload-button{
      position:relative;
      padding-top:5px;
      >p{
        font-size:12px;
      }
      input {
        position: absolute;
        opacity: 0;
        width: 110px;
        left: 0;
        height: 100px;
      }
    }
    .upload-wrap{
      display:inline-block;
      margin-left:80px;
      margin-top:-24px
    }

    li{
      width:110px;
      height:100px;
      float:left;
      text-align:center;
      margin-right:10px;
      margin-bottom:20px;
      border:1px solid #07f;
      border-radius:4px;
      color:#6E8094;
      img{
        margin:3px 0;

      }
      .add-img{
        width:28px;
        height:28px;
      }
    }
    .upload-image {
      color:white;
    }
    .defalut-img{
      line-height:96px;
    }
    .active{
      border:1px solid #49C9FF
    }
  }

  .time-control-btn{
    display: flex;
    justify-content:center;
    padding-top:54px;
    .el-button{
      width:160px;
      font-size:20px;
      font-family:Microsoft YaHei;
      padding: 10px 0px !important;
      border-radius:4px;
    }
    .el-button--default{
      border:1px solid #0077FF;
      color: #BBD4E9;
      background:rgba(30,63,117,0);
    }
    .el-button--primary {
      margin-left: 30px;
      color:rgba(255,255,255,1);
      background:rgba(0,119,255,1);
      border:1px solid rgba(48, 145, 255, 1);
    }
  }
</style>
